export default "__VITE_ASSET__33f9885a__"